'use client';

import { Code } from '@/assets/Code';
import { useLayout } from '@/context/layout-context';
import * as Layout from '@/layout';
import { NOINDEX_ROBOTS } from '@/utils/constants';

export type ErrorPageProps = {
  zmyleError?: ZmyleError;
  error?: Error & { digest?: string };
};

export function ErrorPage({ zmyleError, error }: ErrorPageProps) {
  const { content } = useLayout();

  const { errorPage: errorContent } = content || {};

  const { genericMessage = '', messagesByStatusCode = [] } = errorContent || {};

  const errorStatusCode = String(zmyleError?.status || 500);

  const messageByStatus = messagesByStatusCode.find(
    ({ statusCode }) => statusCode === errorStatusCode,
  );

  const message =
    messageByStatus?.message || genericMessage || error?.message || '';

  return (
    <Layout.Section isFullHeight className="py-0">
      <meta name="robots" content={NOINDEX_ROBOTS} />

      <Layout.SectionContent className="items-center justify-center py-0">
        <div className="flex max-w-lg flex-col items-center space-y-10">
          <h1 className="text-8xl font-bold">{errorStatusCode}</h1>

          <Code />

          <p className="text-center">{message}</p>
        </div>
      </Layout.SectionContent>
    </Layout.Section>
  );
}
